export default "__VITE_ASSET__DSLKKPrS__"